'use client';
import type { Assign } from '@ark-ui/react';
import { Field } from '@ark-ui/react';
import { styled } from '@terra/ui-styled-system';
import {
  type FieldVariantProps,
  field,
  input,
  textarea,
} from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(field);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Field.RootProviderProps>,
    FieldVariantProps
  >
>(Field.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<Assign<HTMLStyledProps<'div'>, Field.RootProps>, FieldVariantProps>
>(Field.Root, 'root');

export const ErrorText = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Field.ErrorTextProps>
>(Field.ErrorText, 'errorText');

export const HelperText = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Field.HelperTextProps>
>(Field.HelperText, 'helperText');

export const Label = withContext<
  HTMLLabelElement,
  Assign<HTMLStyledProps<'label'>, Field.LabelProps>
>(Field.Label, 'label');

export const Select = withContext<
  HTMLSelectElement,
  Assign<HTMLStyledProps<'select'>, Field.SelectProps>
>(Field.Select, 'select');

export type InputProps = ComponentProps<typeof Input>;
export const Input = styled(Field.Input, input);

export type TextareaProps = ComponentProps<typeof Textarea>;
export const Textarea = styled(Field.Textarea, textarea);

export { FieldContext as Context } from '@ark-ui/react';
